import React from 'react';

import { Box, Icon } from '@rbilabs/universal-components';
import { useRouter } from 'expo-router';

import { LinkNoDecoration } from 'components/app-header/styled';
import { VisuallyHidden } from 'components/ucl/visually-hidden';
import { t } from 'state/intl/translations';
import { theme } from 'styles/configure-theme';
import { hiddenAccessibilityPlatformProps } from 'utils/accessibility';
import { routes } from 'utils/routing';

const StyledBackIcon = Icon.withConfig({
  color: theme.token('icon-header-contrast'),
  size: '5',
  ...hiddenAccessibilityPlatformProps,
});

interface BackArrowHistoryProps {
  onPress?: () => void;
  icon?: React.ReactNode;
  color?: string;
  accessibilityLabel?: string;
}
export const BackArrow: React.FC<BackArrowHistoryProps> = ({
  onPress,
  color = theme.token('icon-header-contrast'),
  icon = <StyledBackIcon variant="back" color={color} />,
  accessibilityLabel,
}) => {
  const { back, canGoBack, replace } = useRouter();
  const handleGoBack = () => (canGoBack() ? back() : replace(routes.base));
  const onPressBack = () => handleGoBack();
  const backButtonLabel = accessibilityLabel || t('back');

  return (
    <LinkNoDecoration
      testID="back-arrow-history"
      accessibilityRole="link"
      href="#"
      accessibilityLabel={backButtonLabel}
      onPress={event => {
        event?.preventDefault();
        return onPress ? onPress() : onPressBack();
      }}
    >
      <Box>
        {icon}
        <VisuallyHidden accessibilityLabel={backButtonLabel} />
      </Box>
    </LinkNoDecoration>
  );
};

export const BackArrowHistory = BackArrow;
